import { z } from "zod"
import { DocumentStagesData } from "@/hooks/useDocumentStages"

export const DocumentSchema = z.object({
	id: z.string(),
	name: z.string(),
	file_extension: z.string(),
	size: z.number(),
	upload_location: z.string().optional(),
	created_at: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	relevance_to_search: z.enum(["Exact Match", "Partial Match", "Weak Match"]).optional(),
})

export type Document = z.infer<typeof DocumentSchema> & {
	stagesData?: DocumentStagesData
}

export const CaseSchema = z.object({
	id: z.string(),
	case_name: z.string(),
	plaintiff_first_name: z.string(),
	plaintiff_last_name: z.string(),
	plaintiff_date_of_birth: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	date_of_incident: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	incident_description: z.string().nullable(),
	created_at: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	document_count: z.number(),
})

export type Case = z.infer<typeof CaseSchema>

// Schema for case list response (without full documents)
export const CaseListSchema = z.object({
	id: z.string(),
	case_name: z.string(),
	plaintiff_first_name: z.string(),
	plaintiff_last_name: z.string(),
	plaintiff_date_of_birth: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	date_of_incident: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	incident_description: z.string().nullable(),
	created_at: z.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg)
	}, z.date()),
	document_count: z.number(),
})

export type CaseListItem = z.infer<typeof CaseListSchema>
